import type { CSSProperties } from 'react';

/** How much of the photo's colour goes into the background. */
export const HEADER_TINT_PERCENT = 10;

/**
 * The soft tint a recipe header takes from its photo (docs/partial/appearance-and-themes-spec.md
 * 6.4). The dominant colour comes from the media worker as `#rrggbb`; it is mixed into the
 * theme's background – one part in ten, so even pure black or white behind the muted text keeps
 * 4.5 : 1 in both modes of every theme (`theme-check` test "header tint"). Anything that is not
 * a plain hex colour is ignored: the value is data, it must never reach a style unchecked.
 */
export function headerTintStyle(
  dominantColor: string | null | undefined,
): CSSProperties | undefined {
  if (!dominantColor || !/^#[0-9a-f]{6}$/i.test(dominantColor)) return undefined;
  return {
    backgroundColor: `color-mix(in oklch, ${dominantColor} ${HEADER_TINT_PERCENT}%, var(--color-background))`,
  };
}
